import { usePropertyConfiguration } from "../../../../../components/property-configuration-provider";

/**
 * The current property's IANA time zone (e.g. "Europe/Madrid"), sourced from the
 * Establishment API via PropertyConfigurationProvider. Returns `undefined` while the
 * property configuration is still loading, if the establishment fetch failed (access
 * denied or network error — PropertyConfigurationProvider falls back to `{}` in both
 * cases), or if the property has no time zone configured. Callers MUST NOT substitute
 * the browser's local time zone or UTC when this is `undefined` — see
 * openspec/specs/hotel-timezone-availability/spec.md.
 */
export function useHotelTimeZone(): string | undefined {
  const propertyConfiguration = usePropertyConfiguration();
  return propertyConfiguration?.timeZone;
}
